(() => {
  if (customElements.get('mc-product-description')) return;
  let instance = 0;
  function headingGroup(text) {
    const key = text.replace(/\s+/g, ' ').trim().toLowerCase();
    if (/numery.*(?:porównawcze|zamienne|oe\b)|cross[ -]?reference|zamienniki/.test(key)) return 'references';
    if (/producent|manufacturer/.test(key)) return 'manufacturer';
    if (/zastosowan|fitment|pojazd|vehicle|modele|serie modeli|model series|oznaczenia podwozia|kody silników|typy nadwozia/.test(key)) return 'fitment';
    if (/najważniejsze informacje|dane produktu|dane techniczne|parametr|specyfikac|specification|identyfikacja/.test(key)) return 'technical';
    return 'description';
  }
  customElements.define('mc-product-description', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.enhance(), {once: true});
      else queueMicrotask(() => this.enhance());
    }
    enhance() {
      if (this.dataset.enhanced === 'true' || !this.isConnected) return;
      const producerTemplate = this.querySelector('template[data-mc-producer]');
      const gpsrFallback = this.querySelector('template[data-mc-gpsr-empty]');
      const gpsr = document.querySelector('.mc-gpsr');
      const headings = [...this.querySelectorAll('h2,h3,h4,h5,h6')];
      for (const heading of headings) {
        const key = heading.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        if (key === 'zastosowanie według katalogu ap' || key === 'zastosowanie według katalogu' || key === 'fitment information') heading.textContent = 'Zastosowanie';
        if (key === 'cross-reference parts') heading.textContent = 'Numery porównawcze';
      }
      const textNodes = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
      while (textNodes.nextNode()) {
        const node = textNodes.currentNode;
        if (!node.parentElement?.closest('script,style,template')) node.textContent = node.textContent.replace(/\b(katalog(?:u|iem|owi|i|ów|ach|om)?)\s+AP\b/giu, '$1');
      }
      const labels = {description: 'Opis', technical: 'Dane techniczne', references: 'Numery zamienne / OE', fitment: 'Zastosowanie', manufacturer: 'Producent i GPSR'};
      const groups = new Map(Object.keys(labels).map(key => [key, document.createDocumentFragment()]));
      let current = 'description';
      // Keep all existing nodes, tables, links and attributes; no source text is discarded.
      for (const node of [...this.childNodes]) {
        if (node === producerTemplate || node === gpsrFallback) continue;
        if (node.nodeType === Node.ELEMENT_NODE && node.matches('h2,h3,h4,h5,h6')) current = headingGroup(node.textContent);
        groups.get(current).append(node);
      }
      if (gpsr) {
        gpsr.hidden = false;
        const producer = gpsr.querySelector('.mc-gpsr__producer');
        if (producer) { producer.hidden = false; producer.open = true; }
        groups.get('manufacturer').append(gpsr);
      } else if (producerTemplate && !headings.some(h => headingGroup(h.textContent) === 'manufacturer')) {
        groups.get('manufacturer').append(producerTemplate.content.cloneNode(true));
      }
      if (!groups.get('manufacturer').textContent.trim() && gpsrFallback) groups.get('manufacturer').append(gpsrFallback.content.cloneNode(true));
      producerTemplate?.remove();
      gpsrFallback?.remove();
      const visible = [...groups].filter(([, fragment]) => fragment.textContent.trim() || fragment.querySelector('img,table,video,iframe'));
      this.dataset.enhanced = 'true';
      if (visible.length === 0) {
        for (const [, fragment] of groups) this.append(fragment);
        return;
      }
      const prefix = `mc-description-${++instance}`;
      const tabs = document.createElement('div');
      tabs.className = 'mc-description-tabs';
      tabs.setAttribute('role', 'tablist');
      tabs.setAttribute('aria-label', 'Informacje o produkcie');
      this.append(tabs);
      const buttons = [], panels = [];
      for (const [index, [key, content]] of visible.entries()) {
        const tab = document.createElement('button');
        tab.type = 'button'; tab.className = 'mc-description-tab'; tab.textContent = labels[key];
        tab.id = `${prefix}-${key}-tab`; tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', `${prefix}-${key}-panel`);
        const panel = document.createElement('div');
        panel.id = `${prefix}-${key}-panel`; panel.className = 'mc-description-panel';
        panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0; panel.append(content);
        tabs.append(tab); this.append(panel); buttons.push(tab); panels.push(panel);
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next !== undefined) {event.preventDefault();activate(next);buttons[next].focus();}
        });
      }
      function activate(index) {
        buttons.forEach((button, i) => {button.setAttribute('aria-selected', String(i === index)); button.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index;});
      }
      activate(0);
      const targetId = location.hash.slice(1);
      if (targetId) {
        const target = document.getElementById(targetId);
        const index = panels.findIndex(panel => panel.contains(target));
        if (index >= 0) activate(index);
      }
    }
  });
})();
